(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qitai-inquiry"] && !Shopify.designMode) return;
  try {
    
(function () {
  function fireGtag(eventName, params) {
    if (typeof gtag === 'function') {
      gtag('event', eventName, params);
    } else if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: eventName, ...params });
    }
  }

  function openModal(modalId) {
    var modal = document.getElementById(modalId);
    if (!modal) return;
    modal.removeAttribute('hidden');
    modal.querySelector('.qitai-inquiry-modal__close,input,textarea,button[type=submit]') && (
      modal.querySelector('input,textarea') || modal.querySelector('.qitai-inquiry-modal__close')
    ).focus();
    document.body.style.overflow = 'hidden';
  }

  function closeModal(modalId) {
    var modal = document.getElementById(modalId);
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-open-modal]');
    if (openBtn) {
      openModal(openBtn.getAttribute('data-open-modal'));
      return;
    }

    var closeEl = e.target.closest('[data-close-modal]');
    if (closeEl) {
      closeModal(closeEl.getAttribute('data-close-modal'));
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var openModal = document.querySelector('.qitai-inquiry-modal:not([hidden])');
      if (openModal) {
        closeModal(openModal.id);
      }
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.qitai-inquiry-modal__form');
    if (!form) return;
    e.preventDefault();

    var name = form.querySelector('[name=contact_name]').value.trim();
    var email = form.querySelector('[name=contact_email]').value.trim();
    var qty = form.querySelector('[name=contact_quantity]').value.trim();
    var msg = form.querySelector('[name=contact_message]').value.trim();
    var productId = form.getAttribute('data-product-id');
    var productTitle = form.getAttribute('data-product-title');
    var mailto = form.getAttribute('data-mailto-to');

    if (!name || !email) {
      var firstEmpty = !name
        ? form.querySelector('[name=contact_name]')
        : form.querySelector('[name=contact_email]');
      firstEmpty.focus();
      firstEmpty.reportValidity ? firstEmpty.reportValidity() : alert('Please fill in required fields.');
      return;
    }

    fireGtag('contact_form', {
      product_id: productId,
      product_title: productTitle,
      method: 'email_inquiry'
    });

    var subject = encodeURIComponent('Product Inquiry: ' + productTitle);
    var body = encodeURIComponent(
      'Product: ' + productTitle + '\n' +
      'Name: ' + name + '\n' +
      'Email: ' + email + '\n' +
      (qty ? 'Quantity: ' + qty + '\n' : '') +
      (msg ? 'Message: ' + msg + '\n' : '')
    );

    window.location.href = 'mailto:' + mailto + '?subject=' + subject + '&body=' + body;

    var modal = form.closest('.qitai-inquiry-modal');
    if (modal) setTimeout(function () { closeModal(modal.id); }, 600);
  });

  document.addEventListener('click', function (e) {
    var waBtn = e.target.closest('[data-whatsapp-click]');
    if (waBtn) {
      fireGtag('whatsapp_click', {
        product_id: waBtn.getAttribute('data-product-id'),
        product_title: waBtn.getAttribute('data-product-title')
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
